import FlexContainer from '../../common/flex-container';
import {ReceiveTitle} from '../../formatted-messages';
import OutlinedInput from '../../common/outlined-input';
import React, {useState, type FunctionComponent, useContext} from 'react';
import type WidgetProps from '../types/widget-props.ts';
import round from 'lodash.round';
import styles from '../styles.module.css';
import {SwapWidgetSelect} from '../swap-widget-select/index.tsx';
import {WidgetActiveTokenNameContainer, WidgetActiveTokenNameImg} from '@/components/swap-widget-new/send-widget';
import type {SwapWidgetContextProps} from '@/pages/swap-widget/types/swap-widget-context-props.ts';
import {SwapWidgetContext} from '@/pages/swap-widget';

type ReceiveWidgetProps = WidgetProps;

const ReceiveWidget: FunctionComponent<ReceiveWidgetProps> = (props: ReceiveWidgetProps) => {
  const [isVisibleTokensList, setVisibleTokensList] = useState<boolean>(false);

  const swapWidgetContext = useContext<SwapWidgetContextProps>(SwapWidgetContext);

  const onAmountValueChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const element = evt.target;
    props.onAmountValueChange(element.value);
  };

  const onTokenListOpen = () => {
    setVisibleTokensList(true);
  }

  const onTokenListClose = () => {
    setVisibleTokensList(false);
  }

  return (
    <div
      id="swap-send-widget-container"
      className={styles['widget-item-container']}
    >
      {isVisibleTokensList && (
        <SwapWidgetSelect
          onTokenAddressChange={props.onTokenAddressChange}
          tokensMetadata={props.tokensMetadata}
          onTokenListClose={onTokenListClose}
          rectParameters={props.rectParameters}
          onTokenAddressFavoritesChange={props.onTokenAddressFavoritesChange}
          type="receive"
        />
      )}
      <FlexContainer className={styles['widget-amount-value-container']}>
        <ReceiveTitle/>
        <OutlinedInput readOnly={true} value={swapWidgetContext.receiveAmountValue !== null ? swapWidgetContext.receiveAmountValue : null}
                       onChange={onAmountValueChange} isfullwidth={true}/>
        ${round(swapWidgetContext?.receiveUsdAmount ?? 0, 2)}
      </FlexContainer>
      <FlexContainer className={styles['widget-item-token-container']}>
        <WidgetActiveTokenNameContainer onClick={onTokenListOpen}>
          {swapWidgetContext.receiveTokenImageSrc && swapWidgetContext.receiveTokenName && <>
              <WidgetActiveTokenNameImg src={swapWidgetContext.receiveTokenImageSrc}
                                        alt={swapWidgetContext.receiveTokenName}/>
            {swapWidgetContext.receiveTokenName}
          </>}
        </WidgetActiveTokenNameContainer>
      </FlexContainer>
    </div>
  );
};

export default ReceiveWidget;
